import AsyncSelect from "react-select/async";
import { SearchFieldStyles } from "./SearchFieldStyles";
import servAnaliseProjeto from "../../services/login/servAnaliseProjeto";

const ConsultaPreviaSearchField = ({
    field,
    id,
    setOpenError,
    setErrorMessage,
    disabled = false,
    onKeyDown,
    className = "",
    onConsultaPreviaChange
}) => {

    const loadConsultaPrevia = async (inputValue) => {
        try {

            const response = await servAnaliseProjeto.listarConsultaPrevia(inputValue);

            let data = response.Content.map(mapResponseToValuesAndLabels);

            return data;

        } catch (err) {
            setOpenError(true);
            setErrorMessage(err.response.data.Message);
        }
    };

    const mapResponseToValuesAndLabels = (data) => {
        return {
            value: data.Id,
            label: `${data.CodigoVisual} - ${data.Protocolo} - ${data.TipoProjeto.Nome}`,
            ...data
        };
    };

    const handleChange = (selectedOption) => {
        field.onChange(selectedOption);

        if (onConsultaPreviaChange && selectedOption) {
            onConsultaPreviaChange(selectedOption);
        }
    };

    return (
        <AsyncSelect
            id={id}
            cacheOptions
            placeholder="Selecione uma consulta prévia"
            loadOptions={loadConsultaPrevia}
            defaultOptions
            isDisabled={disabled}
            styles={SearchFieldStyles}
            value={field.value || null}
            onChange={handleChange}
            onKeyDown={onKeyDown}
            className={className}
        />
    );
};

export { ConsultaPreviaSearchField };